import styled from "styled-components";

export const AccountOverviewWrapper = styled.div`
  margin-bottom: 20px;
`;

export const UnderLine = styled.span`
  font-family: HelveticaNeue-Bold, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  color: #006778;
  text-decoration: underline;
  cursor: pointer;
  @media only screen and (max-width: 991px) {
    font-size: 14px;
  }
`;

export const ChartComingSoon = styled.span`
  position: absolute;
  font-family: HelveticaNeue, Helvetica, Arial, sans-serif;
  text-transform: capitalize;
  font-size: 14px;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -ms-flexbox;
  display: flex;
  width: 140px;
  height: 40px;
  background-color: #006778;
  padding-top: 4px;
  color: #fff;
  border-radius: 3px;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  z-index: 100;
  padding: 20px;
`;
